import { useTranslations } from '../../contexts/Translation';
import { Survey, SurveyFilterType } from '../../types';
import React, { useMemo } from 'react';
import Button from '../Button/Button';
import styles from './SurveyFilter.module.css';

interface SurveyTypeFilterProps {
  surveys: Survey[];
  selectedFilter: SurveyFilterType;
  onFilterChange: (filterType: SurveyFilterType) => void;
  isDisabled: boolean;
}

const SurveyTypeFilter: React.FC<SurveyTypeFilterProps> = ({
  surveys,
  selectedFilter,
  onFilterChange,
  isDisabled = false,
}) => {
  const t = useTranslations('cardForm');

  const surveyTypes = useMemo(() => {
    const types = surveys.map((survey) => survey.surveyType);
    return Array.from(new Set(types));
  }, [surveys]);

  const allSurveyTypes: SurveyFilterType[] = useMemo(() => ['all', ...surveyTypes], [surveyTypes]);

  return (
    <div className={styles.container}>
      <span className={styles.label}>{t('surveyTypeFilterLabel')}</span>
      {allSurveyTypes.map((type) => (
        <Button
          key={type}
          onClick={() => onFilterChange(type)}
          variant={selectedFilter === type ? 'cta' : 'secondary'}
          className={[styles.button, isDisabled && styles.buttonDisabled].filter(Boolean).join(' ')}
          disabled={isDisabled}
        >
          {type.charAt(0).toUpperCase() + type.slice(1)}
        </Button>
      ))}
    </div>
  );
};

export default React.memo(SurveyTypeFilter);
